import React, { useEffect, useState } from "react";
import "./Inner_Footer_Text_Component.css";
import { ApSetup } from "../../../utils/apis/master/Master";
import HtmlToReactParser from "html-to-react";

const Inner_Footer_Text_Component = () => {
  const [appSetup, setAppSetup] = useState({});

  const getAppSetup = async () => {
    const res = await ApSetup();
    if (res?.success) {
      setAppSetup(res.data);
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  const parser = new HtmlToReactParser.Parser();

  return (
    <section className="premium-footer-text">
      <div className="footer-glass-container">
        <div className="footer-content">
          {appSetup?.footer_content ? (
            <div className="rendered-footer">
              {parser.parse(appSetup.footer_content)}
            </div>
          ) : (
            <p className="loading-text">Loading footer content...</p>
          )}
        </div>

        {/* Optional subtle branding / copyright (you can customize or remove) */}
        <div className="footer-branding">
          <p>© {new Date().getFullYear()} All rights reserved.</p>
        </div>
      </div>
    </section>
  );
};

export default Inner_Footer_Text_Component;